const fileTypesMap = {
  "special offer": "Спецпредложения",
  partner: "Партнеры",
  "partner card": "Партнеры карты",
  "partner category": "Партнеры категории",
  "partner step": "Партнеры шаги",
  "partner promotion": "Партнеры акции",
  "campaign image": "Изображение акции",
  "campaign image (large)": "Изображение акции (большое)",
  "barclub promotion": "Барный клуб акции",
  document: "Документ",
  report: "Отчет",
  other: "Другие",
};

const collections = {
  type(value) {
    return fileTypesMap[value];
  },
  image_type(value) {
    return fileTypesMap[value];
  },
  file_type(value) {
    return fileTypesMap[value];
  },
  doc_type(value) {
    const map = {
      regional: "Региональные инструкции",
      federal: "Федеральные инструкции",
    };
    return map[value];
  },
  roles(value) {
    const map = {
      super_admin: "Главный администратор",
      section_admin: "Администратор секций",
      regional_admin: "Региональный администратор",
      federal_admin: "Федеральный администратор",
      all_document_admin: "Администратор раздела «Документы»",
      feedback_admin: "Администратор раздела «Обратная связь»",
    };
    return map[value];
  },
};

export function enumFilter(name, value) {
  if (typeof collections[name] === "function") {
    return collections[name](value) || value;
  }
  return value;
}

export function getValuesForTableColumnFilter(type) {
  const values = [];
  if (type === "file") {
    for (const value in fileTypesMap) {
      if (Object.hasOwnProperty.call(fileTypesMap, value)) {
        values.push({
          value: value,
          text: fileTypesMap[value],
        });
      }
    }
  }
  return values;
}
